export default {
  stats: {
    orders: 'Ordrer',
    sales: 'Omsætning',
  },
};
